import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const freeShippingCopyPDPSelector = createSelector(testTargetOffersSelector, offers => offers.freeShippingCopyPDP || Empty.Object);

export { freeShippingCopyPDPSelector };
